import {
  ComplianceCheck_Read,
  ComplianceIssue as ComplianceIssue_Read,
} from '@treadinc/horizon-api-spec';

export class ComplianceIssue {
  constructor(
    private _type: string,
    private _entity: string | null,
    private _documentType: string,
    private _documentTypeId: string,
    private _expiresAt: string | null,
  ) {}

  public static parse(proto: ComplianceIssue_Read) {
    return new ComplianceIssue(
      proto.type,
      proto.entity ?? null,
      proto.document_type,
      proto.document_type_id,
      proto.expires_at ?? null,
    );
  }

  public get type() {
    return this._type;
  }

  public get entity() {
    return this._entity;
  }

  public get documentType() {
    return this._documentType;
  }

  public get documentTypeId() {
    return this._documentTypeId;
  }

  public get expiresAt() {
    return this._expiresAt;
  }
}

export class ComplianceCheck {
  constructor(
    private _hasIssues: boolean,
    private _warnings: ComplianceIssue[],
    private _blocking: ComplianceIssue[],
  ) {}

  public static parse(proto: ComplianceCheck_Read) {
    return new ComplianceCheck(
      proto.has_issues,
      (proto.warnings ?? []).map(ComplianceIssue.parse),
      (proto.blocking ?? []).map(ComplianceIssue.parse),
    );
  }

  public get hasIssues() {
    return this._hasIssues;
  }

  public get warnings() {
    return this._warnings;
  }

  public get blocking() {
    return this._blocking;
  }
}
